<div class="tasks-container">
  <rotec-file-upload-v2
    [acceptedFileFormats]="['.xlsx', '.xls']"
    (filesChange)="upload($event)"
  ></rotec-file-upload-v2>
  @if (!!file) {
    <div>
      <p id="selected-file">{{ file.name }}</p>
    </div>
  }
  @if (errorMsg) {
    <div class="rc-mt-25 error">{{ errorMsg }}</div>
  }
  <div class="template">
    <p class="template__title" translate>MC_Please use this template</p>
    <div class="template__list">
      <p><a [href]="getExcelTemplate('de')" target="_blank" translate>MC_German</a></p>
      <p><a [href]="getExcelTemplate('en')" target="_blank" translate>MC_English</a></p>
    </div>
  </div>
</div>
